import { RefObject, useEffect, useRef, useState } from 'react'

const useIsVisible = (elRef?: RefObject<HTMLElement>, threshold = 1) => {
  const [isVisible, setIsVisible] = useState(false)
  const observerRef = useRef<IntersectionObserver | null>(null)

  useEffect(() => {
    let observer: IntersectionObserver | undefined = undefined
    if (elRef?.current && !isVisible) {
      observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              setIsVisible(true)
              if (observer) {
                observer.unobserve(entry.target)
                observer.disconnect()
              }
            }
          })
        },
        { threshold },
      )
      observer.observe(elRef.current)
    }
    if (!observerRef.current && observer) {
      observerRef.current = observer
    }

    return () => {
      if (elRef?.current && observerRef.current) {
        observerRef.current.unobserve(elRef.current)
        observerRef.current.disconnect()
      }
    }
  }, [elRef?.current, isVisible])

  return { isVisible }
}

export default useIsVisible
